import { motion } from 'framer-motion';
import { css, styled } from 'styled-components';
import CopyIcon2 from '../../assets/icons/CopyIcon2';

const IconContainer = styled(motion.div)<{ $clipboard?: boolean }>`
  transition: all 220ms cubic-bezier(0.175, 0.885, 0.32, 1.1);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 24px;
  svg {
    display: block;
  }
  svg,
  svg path,
  svg rect {
    transition: inherit;
  }
  svg path:first-child {
    transform-origin: 50% 50%;
    fill: var(--pcm-body-background);
    stroke: var(--pcm-body-color-secondary);
  }
  svg rect {
    transform-origin: 53% 63%;
    fill: var(--pcm-body-background);
    stroke: var(--pcm-body-color-secondary);
  }
  svg path:last-child {
    opacity: 0;
    stroke: #fff !important;
    transform: translate(11.75px, 10px) rotate(90deg) scale(0.6);
  }
  ${(props) =>
    props.$clipboard
      ? css`
          svg {
            transition-delay: 0ms;
            path:first-child {
              opacity: 0;
              transform: rotate(-90deg) scale(0.2);
            }
            rect {
              rx: 10px;
              fill: var(--pcm-accent-color);
              stroke: var(--pcm-accent-color);
              transform: rotate(-90deg) scale(1.45);
            }
            path:last-child {
              transition-delay: 100ms;
              opacity: 1;
              transform: translate(7.75px, 9.5px);
            }
          }
        `
      : css`
          &:hover {
          }
          &:hover:active {
          }
        `}
`;

const CopyToClipboardIcon = ({ copied, small }: { copied?: boolean; small?: boolean }) => (
  <IconContainer $clipboard={copied}>
    <CopyIcon2
      style={{
        transform: small ? 'scale(1)' : 'translateX(3px) scale(1.5)',
        opacity: small || copied ? 1 : 0.6,
      }}
    />
  </IconContainer>
);

export default CopyToClipboardIcon;
